import { render } from "./Temp.vue?vue&type=template&id=227bf926"
import script from "./Temp.vue?vue&type=script&lang=js"
export * from "./Temp.vue?vue&type=script&lang=js"
script.render = render

export default script